<div class="iaq-unauthorized-card-container" [ngStyle]="{'background-image':' url(assets/images/critical_quality_air.png)'}">
  <div class="iaq-unauthorized-card-text-container">
    <span class="iaq-unauthorized-card-text">You don't have access to this building</span>
  </div>
</div>
